
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/retail",
      function () {
        return require("private-next-pages/cases/retail/index.tsx");
      }
    ]);
  